import { render, staticRenderFns } from "./ClientDetailsView.vue?vue&type=template&id=22990b22&scoped=true&"
import script from "./ClientDetailsView.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22990b22",
  null
  
)

export default component.exports